@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.action-button {
  margin-left: 10px;
  > button {
    background: @containers--action-button--background-color;
    border-top: 1px solid @containers--action-button--border-color;
    border-bottom: 1px solid @containers--action-button--border-color;
  }
}
